<template>
  <div class="modal fade" tabindex="-1" :id="id">
    <div class="modal-dialog modal-lg">
      <form @submit.prevent="createGroupDiscussion" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('chat.create_discussion') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor"/>
                </svg>
              </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />

            <div class="row">
              <div class="col-md-6">
                <input v-model="formData.group_type" type="radio" class="btn-check" name="discussion_type" value="PUBLIC"  id="kt_radio_buttons_2_option_1"/>
                <label class="btn btn-outline btn-outline-dashed btn-active-light-primary p-7 d-flex align-items-center mb-5" for="kt_radio_buttons_2_option_1">
                  <i class="fas fa-globe fs-4x me-4"><span class="path1"></span><span class="path2"></span></i>
                  <span class="d-block fw-semibold text-start">
                    <span class="text-gray-900 fw-bold d-block fs-3">Groupe public</span>
                    <span class="text-muted fw-semibold fs-6">N'importe qui peut rejoindre</span>
                </span>
                </label>
              </div>
              <div class="col-md-6">
                <input v-model="formData.group_type" type="radio" class="btn-check" name="discussion_type" value="PRIVATE" id="kt_radio_buttons_2_option_2"/>
                <label class="btn btn-outline btn-outline-dashed btn-active-light-primary p-7 d-flex align-items-center" for="kt_radio_buttons_2_option_2">
                  <i class="fas fa-lock fs-4x me-4"><span class="path1"></span><span class="path2"></span><span class="path3"></span></i>

                  <span class="d-block fw-semibold text-start">
                  <span class="text-gray-900 fw-bold d-block fs-3">Groupe privé</span>
                  <span class="text-muted fw-semibold fs-6">Seulement les membres invités</span>
              </span>
                </label>
              </div>
            </div>

            <div class="row">
              <div class="row">
                <div class="col-md-12">
                  <Input
                      containerClass="col-md-12 mb-5"
                      :name="`${id}-name`"
                      type="text"
                      :label="$t('chat.group_name')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="true" size="lg"
                      :placeholder="$t('chat.group_name')"
                      v-model="formData.name"
                  />
                </div>
                <div class="col-md-12" v-if="formData.group_type == 'PRIVATE'">
                  <Select2
                      :parent-id="'#'+id"
                      containerClass="col-12 mt-auto mb-5"
                      :name="`${id}-gender`"
                      type="text"
                      :label="$t('chat.select_members')"
                      labelClass="form-label fs-6 text-black"
                      selectClass="form-select form-select-solid"
                      :isRequired="formData.group_type == 'PRIVATE'" size="lg"
                      :placeholder="$t('chat.select_members')"
                      v-model="formData.users"
                      :multiple="true">
                    <option v-for="user in users" :value="user.id">{{ user.fullname }}</option>$
                  </Select2>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="processing"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import {ref, defineEmits, defineProps, computed, onMounted} from "vue";
import Select2 from "@/components/Select2.vue";
import Input from "@/components/Input.vue";
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText"
import Button from "@/components/Button"
import {useRouter} from "vue-router";

const store = useStore()
const router = useRouter()
const emits = defineEmits(['afterUpdate', 'afterCreate'])
const props = defineProps({
  id: { type: String, required: true},
  moduleClass: {type: String, default: ''},
  moduleId: {type: String, default: ''},
})

const processing = ref(false)
const formData = ref({
  'discussion_type': 'group', //personal or group
  'group_type': 'PUBLIC', //PUBLIC or PRIVATE
  'users': []
})

const users = computed(() => store.getters['chat/getUsers'])

function closeModal(){
  $('#'+props.id).modal('toggle')
}

onMounted(() => {
  loadData()
})

function loadData() {
  Promise.all([
    store.dispatch('chat/loadAllUsers', {module_id: props.moduleId, module_class: props.moduleClass}),
  ])
}

function resetForm() {
  formData.value = {
    'discussion_type': 'group', //personal or group
    'group_type': 'PUBLIC', //PUBLIC or PRIVATE
    'users': []
  }
}

function createGroupDiscussion() {
  processing.value = true
  const usersSelected = []
  for (let i = 0; i < formData.value.users.length; i++) {
    const user = users.value.find(u => u.id === formData.value.users[i]); // Fix find usage
    if (user) {
      usersSelected.push({
        user_id: user.id,
        user_type: user.model,
      });
    }
  }

  store.dispatch('chat/createGroupDiscussion', {
    module_id: props.moduleId,
    module_class: props.moduleClass,
    name: formData.value.name,
    group_type: formData.value.group_type,
    users: usersSelected,
  })
      .then(res => {
        closeModal()
        resetForm()

        window.toastr['success'](i18n.global.t('chat.discussion_created_successfully'))
      })
      .finally(() => processing.value = false)
}

</script>